import React from "react";
import { useNavigate } from "react-router-dom";
import { ForgotPassword } from "../../components/ForgotPassword";

export function ForgotPasswordPage() {
  const navigate = useNavigate();

  const handleNavigateToLogin = () => {
    navigate("/auth/login");
  };

  return <ForgotPassword onNavigateToLogin={handleNavigateToLogin} />;
}
